
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1412Dialog extends Serenity.EntityDialog<Report_1412Row, any> {
        protected getFormKey() { return Report_1412Form.formKey; }
        protected getIdProperty() { return Report_1412Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1412Row.localTextPrefix; }
        protected getNameProperty() { return Report_1412Row.nameProperty; }
        protected getService() { return Report_1412Service.baseUrl; }
        protected getDeletePermission() { return Report_1412Row.deletePermission; }
        protected getInsertPermission() { return Report_1412Row.insertPermission; }
        protected getUpdatePermission() { return Report_1412Row.updatePermission; }

        protected form = new Report_1412Form(this.idPrefix);

    }
}